<div class="sidebar-wrapper">
    <div class="logo">
        <a class="simple-text">
            <div class="logo-img">
                <img [src]="logo" style="width: 100px; margin: 0px auto;" />
            </div>
            <div>
                {{appName}}
            </div>
        </a>
    </div>
    <ul class="nav responsive-nav">
        <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{menuItem.class}}">
            <a [routerLink]="[menuItem.path]" (click)="handleMenuItemClick(menuItem)">
                <i class="{{menuItem.icon}}"></i>
                <p>{{menuItem.title}}</p>
            </a>
        </li>
        <li>
            <a style="cursor: pointer;" (click)="logOut()">
                <i class="fa fa-sign-out"></i>

                <p>Log out</p>
            </a>
        </li>
    </ul>
</div>
<app-subjectcombination [isSubjectPopupVisible]="isSubjectPopupVisible" [dismissable]="dismissable"
    (closeEvent)="onClose($event)"></app-subjectcombination>
<app-verify-account-popup [isPopupVisible]="isPopupVisible"></app-verify-account-popup>
<div *ngIf="isPlanPopupVisible" class="popupPlan card p-2">
    <div style="position: absolute; right: 0px; cursor: pointer;" (click)="close()">close<i class="fa fa-close"></i>
    </div>

    <div class="popup-container">
        <div class="popup-body">
            <h3 class="text-center">Continue to Buy Plan</h3>
            <div class="text-center p-3 pt-0">
                <div>
                    <div class="txt text-left">
                        <h1 style="color: #6a6a6a;" class="mb-2">{{plan.title}}</h1>

                    </div>

                    <ul style="list-style: none !important; padding: 2px;">
                        <li>
                            <p class="text-left"><i class="fa fa-codepen "></i> {{plan.currency}}{{plan.price}}</p>
                        </li>
                        <li>
                            <p class="text-left"> <i class="fa fa-codepen"></i> {{plan.attempts}} credits</p>
                        </li>
                        <li>
                            <p class="text-left"><i class="fa fa-codepen"></i> Valid for {{plan.validity}} days.</p>
                        </li>
                    </ul>

                    <button href="javascript:void(0);" class="btn btn-lg btn-success mt-2 p-3" [disabled]="disableBtn"
                        (click)="buy()">Buy Plan</button>
                </div>
            </div>

        </div>
    </div>
</div>